var map = {
	"./check-circle-fill.svg": 3722,
	"./chevron-down.png": 8441,
	"./chevron-down.svg": 6592,
	"./facebook.svg": 4225,
	"./main-section-bg.png": 7784,
	"./mclaut_logo.png": 4423,
	"./news_item.png": 5642,
	"./page-navigation.svg": 8149,
	"./paginator-arrow-left.svg": 9326,
	"./paginator-arrow-right.svg": 4508,
	"./poll.svg": 5631,
	"./site_logo.png": 5238,
	"./upload-warning.svg": 9987,
	"./visual-impairment.svg": 9120,
	"./yellow_phone.png": 9758,
	"./zoom-out.svg": 2853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2791;